import React, {useContext} from 'react';
import FilterGroupsLarge from '../filter/large/FilterGroups.jsx';
import Landmark from '@core/scripts/components/landmark-adapter';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import {useDispatch} from 'react-redux';
import {TertiaryButton} from '@bonprix/design-system';
import {openFilter} from '../FilterSlice.jsx';
import {Constants} from '../view-constants';
import {useTrinity} from '../hooks/use-trinity.js';
import {useBreakpointUp} from "bonprix-design-system";

function Filter({filterContent, landmarkContent, filterSubmit, isSticky}) {
    const {texts, shopId} = useContext(articleOverviewStaticContext);
    const breakpointLUp = useBreakpointUp('l');

    const dispatch = useDispatch();
    const {sendClickBasic, sendFilterView} = useTrinity();

    return (
        <>
            {breakpointLUp ? (
                <FilterGroupsLarge
                    shopIdFilterGroup={filterContent.shopIdFilterGroup}
                    filterGroups={filterContent.filterGroups}
                    hits={filterContent.hits}
                    hasTooManyFilterGroupsForInitialDisplay={filterContent.hasTooManyFilterGroupsForInitialDisplay}
                    filterSubmit={filterSubmit}
                    isSticky={isSticky}
                    filterViewValue={landmarkContent?.filterViewLandmark}
                />
            ) : (
                renderFilterButton()
            )}
        </>
    );

    function renderFilterButton() {
        const handleClick = () => {
            dispatch(openFilter());
            sendClickBasic('open_filter', Constants.FILTER_VIEW_EVENT_VERSION_CONTROLGROUP);
            const filterViewValue = landmarkContent?.filterViewLandmark;
            if (filterViewValue) {
                sendFilterView('filter_layer', filterViewValue, Constants.FILTER_VIEW_EVENT_VERSION_TESTGROUP);
                const landmarkData = {
                    filter_view: filterViewValue,
                    filter_view_shopId: shopId.current,
                };
                Landmark.sendActionLandmark(landmarkData);
            }
        };
        return (
            <div className="article-overview__filter-order-button-wrapper -filter" test-ref__filter-sticky-button="">
                <div className="article-overview__filter-order-button">
                    <TertiaryButton
                        iconPosition="start"
                        onClick={handleClick}
                        icon="control-panel"
                        small={true}
                    >
                        {texts.filter_showResult}
                    </TertiaryButton>
                </div>
            </div>
        );
    }
}

export default Filter;
